var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9444_2645",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0515137,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9444_2645)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.11401 14L10.0515 11.0625L12.989 14L14.0515 12.9375L11.114 10L14.0515 7.0625L12.989 6L10.0515 8.9375L7.11401 6L6.05151 7.0625L8.98901 10L6.05151 12.9375L7.11401 14ZM10.0515 18C8.95429 18 7.91957 17.7917 6.94735 17.375C5.97512 16.9583 5.12443 16.3854 4.39526 15.6562C3.6661 14.9271 3.09318 14.0764 2.67651 13.1042C2.25985 12.1319 2.05151 11.0972 2.05151 10C2.05151 8.88889 2.25985 7.85069 2.67651 6.88542C3.09318 5.92014 3.6661 5.07292 4.39526 4.34375C5.12443 3.61458 5.97512 3.04167 6.94735 2.625C7.91957 2.20833 8.95429 2 10.0515 2C11.1626 2 12.2008 2.20833 13.1661 2.625C14.1314 3.04167 14.9786 3.61458 15.7078 4.34375C16.4369 5.07292 17.0098 5.92014 17.4265 6.88542C17.8432 7.85069 18.0515 8.88889 18.0515 10C18.0515 11.0972 17.8432 12.1319 17.4265 13.1042C17.0098 14.0764 16.4369 14.9271 15.7078 15.6562C14.9786 16.3854 14.1314 16.9583 13.1661 17.375C12.2008 17.7917 11.1626 18 10.0515 18ZM10.0515 16.5C11.8571 16.5 13.3918 15.8681 14.6557 14.6042C15.9196 13.3403 16.5515 11.8056 16.5515 10C16.5515 8.19444 15.9196 6.65972 14.6557 5.39583C13.3918 4.13194 11.8571 3.5 10.0515 3.5C8.24596 3.5 6.71124 4.13194 5.44735 5.39583C4.18346 6.65972 3.55151 8.19444 3.55151 10C3.55151 11.8056 4.18346 13.3403 5.44735 14.6042C6.71124 15.8681 8.24596 16.5 10.0515 16.5Z",
    fill: "#D60000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIcon);
export default __webpack_public_path__ + "static/media/cross_Icon.c8944736fe195c58c90fa6f401969f99.svg";
export { ForwardRef as ReactComponent };